import * as React from "react";
import User from "../../model/user/User";
import MapUtils from "../../utils/MapUtils";
import {getUserLocation} from "../../store/view/user";
import {isNullOrUndefined} from "util";
import {Icon} from "../../hiberUiKit/src/atoms/Icon/Icon";
import IconSmall from "../../hiberUiKit/src/atoms/Icon/IconSmall";
import UserLocation from "../../model/userLocation/UserLocation";
import {Option} from "ts-option";

const classNames = require("classnames");

interface ComponentProps {
	/**
	 * User presented in row.
	 */
	user: User;
	/**
	 * Is item active (selected)
	 */
	active?: boolean
	/**
	 * On engineer click.
	 */
	onClick?: (active: boolean) => void
	/**
	 * Handles click on focus button on map legend row.
	 * @param {User} user
	 */
	onFocusButtonClick?: (user: User) => void;
}

type Props = ComponentProps

/**
 * Schedule map legend sales engineer list item component.
 */
export default class MapLegendEngineer extends React.PureComponent<Props, {}> {
	render() {
		const location = getUserLocation(this.props.user.id);
		const classFromProps = classNames({
			"c-map-legend-item": true,
			"is-inactive": !isNullOrUndefined(this.props.active) && !this.props.active
		});
		return (
			<div className={classFromProps} onClick={() => this.props.onClick && this.props.onClick(this.props.active)}>
				<div>
					<img src={MapUtils.getSEInitialsMarker(this.props.user)}/>
				</div>
				<div className={"c-map-legend-item_details"}>
					{this.props.user.getAssigneeDisplayName()}
					{this.props.user.disabled ?
						<span>DISABLED</span> :
						<small>{this.getStatus(location)}</small>}
				</div>
				{this.renderTargetIcon(location)}
			</div>
		);
	}

	renderTargetIcon(location: Option<UserLocation>) {
		if (this.props.active && location.isDefined && this.props.onFocusButtonClick) {
			return (
				<IconSmall icon={Icon.Watch} variant={"blue"}
						   onClick={(event) => {
							   event.stopPropagation();
							   this.props.onFocusButtonClick(this.props.user)
						   }}/>
			)
		}
	}

	/**
	 * @returns {string} online/offline user status string.
	 */
	getStatus(location: Option<UserLocation>): string {
		const isOffline = location.map(l => l.isOffline()).getOrElse(true);
		return location.map(l => isOffline ? l.createdAt.fromNow() : "Online now").getOrElse("Offline")
	};
}
